// Única decisión real del rastreo, aparte a propósito: sin React ni plugin nativo
// encima se puede probar de un vistazo (ver tracking.check.ts).
export interface TrackInput {
  /** Solo se rastrea a repartidores. */
  isDriver: boolean
  /** ¿Tiene alguna entrega en "en_ruta" o "en_sitio"? */
  onRoute: boolean
  /** ¿El rastreo ya está encendido? */
  sharing: boolean
  /** Se cortó por exceder las 16h; no reencender hasta cerrar la ruta. */
  cutOff: boolean
}

export type TrackAction = 'start' | 'stop' | 'nada'

export function trackDecision({ isDriver, onRoute, sharing, cutOff }: TrackInput): TrackAction {
  if (!isDriver) return 'nada'
  if (!onRoute) return sharing ? 'stop' : 'nada'
  return !sharing && !cutOff ? 'start' : 'nada'
}
